import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeEvery,
  takeLatest,
  cancelled
} from 'redux-saga/effects'
import * as R from 'ramda'

import {
  get
} from 'helpers/RequestUtil'

import {
  MOUNT,
  UNMOUNT,
  CHANGE_PROJECT_ROLE,
  FETCH_PROJECT_PERMISSION
} from './constants'

import {
  clearProjectRole,
  updateProjectRole,
  changeProjectRole,
  changeProjectRoleStart,
  changeProjectRoleSuccess,
  enableRoleStatus,
  disableRoleStatus,
  clearProjectId,
  updateProjectId,
  fetchProjectPermissionStart,
  fetchProjectPermissionSuccess,
  fetchProjectPermissionError,
} from './actions'

import {
  projectIdSelector,
} from './selectors'

function* fetchProjectPermission(projectId) {
  try {
    yield put(fetchProjectPermissionStart())
    const data = yield call(get, `/api/fulcrum/projects/${projectId}/permissions`)
    const { entities: { project_permissions: permissions }} = data
    const roles = R.map(R.prop('role'))(R.values(permissions))
    yield put(fetchProjectPermissionSuccess())
    return roles
  } catch(error) {
    yield put(fetchProjectPermissionError(error))
  }
}

function* handleChangeProjectRole({ roles }) {
  try {
    yield put(changeProjectRoleStart())
    yield put(updateProjectRole(roles))
    yield put(enableRoleStatus())
    yield put(changeProjectRoleSuccess())
  } finally {
    if (yield cancelled()) {
      yield put(disableRoleStatus())
      yield put(clearProjectRole())
    }
  }
}

function* handleMount(action) {
  const { projectId } = action
  const id = yield select(projectIdSelector)
  if (projectId !== id) {
    yield put(clearProjectRole())
    const roles = yield call(fetchProjectPermission, projectId)
    yield put(updateProjectId(projectId))
    yield put(changeProjectRole(roles))
  } else {
    // !IMPORTANT keep this or else it won't update selectors state
    yield put(enableRoleStatus())
  }
}

function* handleUnmount() {
  yield put(disableRoleStatus())
}

function* watchChangeProjectRole() {
  yield takeLatest(CHANGE_PROJECT_ROLE, handleChangeProjectRole)
}

function* watchMount() {
  yield takeEvery(MOUNT, handleMount)
}

function* watchUnmount() {
  yield takeEvery(UNMOUNT, handleUnmount)
}

function* loadSagas() {
  yield all([
    fork(watchMount),
    fork(watchUnmount),
    fork(watchChangeProjectRole),
  ])
}

export default loadSagas
